import debounce from "lodash.debounce";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Grid, Stack } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import Title from "../../common/Title";
import Search from "../Search/Search";
import useAxios from "../../../hooks/useAxios";
import { OPERATIONS } from "../../../constants/value";
import { __getOrderInfoBatches } from "../../../api/sim";
import BatchList from "../../common/BatchList";

const OrderInfo = ({ client }) => {
  const [data, setData] = useState([]);
  const [searchActive, setSearchActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [metaData, setMetaData] = useState({
    page: 1,
    page_size: 100,
    total: 1,
  });

  const nav = useNavigate();
  const [response, call, loading] = useAxios({ ...__getOrderInfoBatches });

  const debouncedFetchData = useMemo(() => {
    return debounce((query) => {
      call(query);
    }, 400);
  }, [call]);

  useEffect(() => {
    debouncedFetchData({
      params: {
        client,
        page: currentPage,
        page_size: pageSize,
        search_query: undefined,
      },
    });

    return () => {
      debouncedFetchData.cancel();
    };
  }, [currentPage, pageSize, client]);

  useEffect(() => {
    if (response && response.status) {
      setMetaData({
        page: response.data.page,
        page_size: response.data.page_size,
        total: response.data.total,
      });
      setData(response.data.data);
    }
  }, [response]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (newPageSize) => {
    setCurrentPage(1);
    setPageSize(newPageSize);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        sx={{ textTransform: "capitalize" }}
        content={`${client ? client : ""} Order Info`}
        gutterBottom
      />

      <Grid container justifyContent="space-between" spacing={2} mb={2}>
        <Grid item>
          <Stack spacing={2} direction="row">
            <LoadingButton
              loading={loading}
              variant="contained"
              color="primary"
              onClick={() => nav("form")}
            >
              Fetch Order Info
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>

      <Search
        key={`${client}-order-info-search`}
        client={client}
        operation={OPERATIONS.order_info}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />

      {!searchActive && response ? (
        <BatchList
          data={data}
          loading={loading}
          meta={metaData}
          handlePageChange={handlePageChange}
          handlePageSizeChange={handlePageSizeChange}
        />
      ) : !searchActive ? (
        <Title content="Please wait..." variant="subtitle2" gutterBottom />
      ) : null}
    </Box>
  );
};

export default OrderInfo;
